import type { ElibooApp } from '@eliboo/api-models';

import { HttpContext } from '@angular/common/http';
import { inject, signal } from '@angular/core';
import { type ActivatedRouteSnapshot, RedirectCommand, type ResolveFn, Router, type RouterStateSnapshot } from '@angular/router';
import { CacheService } from '@delon/cache';
import { MICRO_APP_SIGNATURE_CONTEXT } from '@eliboo/micro-ng/http/interceptor';
import { catchError, map, of, switchMap } from 'rxjs';

import { useApiOptions } from '../api';
import { useApiGetBusinessLicensePending } from '../api/channel/use-business-license-pending.api';
import { useApiGetH5businessLicenseInfo } from '../api/channel/use-business-licenseInfo-sheet.api';
import { TaxUserService } from '../service';
export interface LogoutResolverResult {
  businessLicenseInfoSheet: ElibooApp.ReturnBusinessLicenseInfoSheetDTO;
  businessLicenseInfoSheetId?: number;
  pending: ElibooApp.BusinessLicensePendingDTO;
}
export const LogoutResolver: ResolveFn<LogoutResolverResult> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  let getH5businessLicenseInfo = useApiGetH5businessLicenseInfo();
  let getBusinessLicensePending = useApiGetBusinessLicensePending();
  const routeConfig = route.routeConfig;
  const router = inject(Router);
  const cacheSrv = inject(CacheService);
  const redirectCommand = (msg = '参数错误，请联系工作人员') => new RedirectCommand(router.parseUrl(`/tax/result?msg=${msg}`));
  // 白名单
  const whiteList = ['logout', 'logout-sign'];
  if (!routeConfig?.path) {
    return of(redirectCommand());
  }
  if (!whiteList.includes(routeConfig?.path)) {
    return of(redirectCommand());
  }
  let businessLicenseInfoSheetId: number | undefined;

  // 签名
  const routeSignature = signal<string>('');
  if (routeConfig?.path === 'logout') {
    const userSvc = inject(TaxUserService);
    businessLicenseInfoSheetId = userSvc.associationId();
    // 设置值
  }
  if (routeConfig?.path === 'logout-sign') {
    if (!route.queryParams['signature'] || !route.queryParams['businessLicenseInfoSheetId']) {
      return of(redirectCommand());
    }
    routeSignature.set(route.queryParams['signature']);
    const signature = useApiOptions({
      context: new HttpContext().set(MICRO_APP_SIGNATURE_CONTEXT, { getSignature: () => of(routeSignature()) }),
    }, true);
    if (route.queryParams['businessLicenseInfoSheetId']) {
      businessLicenseInfoSheetId = Number(route.queryParams['businessLicenseInfoSheetId']);
      if (isNaN(businessLicenseInfoSheetId)) {
        return of(redirectCommand());
      }
    }
    getH5businessLicenseInfo = useApiGetH5businessLicenseInfo(signature);
    getBusinessLicensePending = useApiGetBusinessLicensePending(signature);
  }

  console.log('invoiceResolver', route, state);
  // 获取营业执照信息

  return getH5businessLicenseInfo
    .api({
      businessLicenseInfoSheetId: businessLicenseInfoSheetId,
    })
    .pipe(
      map((res) => {
        if (!res.data) {
          throw new Error('获取营业执照信息失败');
        }
        if (routeConfig?.path === 'logout-sign') {
          const key = res.data.unifySocialCreditCode + '_signature';
          const noTokenKey = routeConfig?.path + '_noToken';
          cacheSrv.set(noTokenKey, res.data.unifySocialCreditCode, { expire: 3600 * 24 });
          cacheSrv.set(key, routeSignature(), { expire: 3600 * 24 });
        }
        return res.data;
      }),
      switchMap((businessLicenseInfoSheet) => {
        return getBusinessLicensePending
          .api({
            idCard: businessLicenseInfoSheet.idNumber!,
            mobile: businessLicenseInfoSheet.phoneNumber!,
          })
          .pipe(
            map((res) => ({
              businessLicenseInfoSheet,
              pending: res.data,
              businessLicenseInfoSheetId,
            })),
          );
      }),
      catchError((err) => {
        console.error('获取注销信息失败', err);
        return of(redirectCommand());
      }),
    );
};
